import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';
import { NavigateItem } from '@/components/ui/NavigateItem/NavigateItem';
import { Picture } from '@/components/ui/Picture/Picture';

import css from './styles.module.scss';

import infoPng from '/img/icons/info.png';
import infoWebp from '/img/icons/info.webp';

interface LotteryRulesNavLinkProps {
  className?: string;
}

const LotteryRulesNavLink: FC<LotteryRulesNavLinkProps> = ({ className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <NavigateItem
      label={t('Rules')}
      className={cn(className)}
      parentClassName={cn(css.effects, 'flex items-center justify-center')}
      onClick={() => navigate(AppRoute.LOTTERY + '/faq')}
    >
      <Picture
        img={infoPng}
        webp={infoWebp}
        alt="info"
        className="size-[36px]"
      />
    </NavigateItem>
  );
};

export { LotteryRulesNavLink };
